import $ from 'jquery';
import OP3MovingImage from '../Element/MovingImage';

export default class CreateNewPage {
    /**
     * Constructor.
     *
     * @return {Void}
     */
    constructor() {
        this.useTemplateConfirm = null;
        this.previewTemplateConfirm = null;
        this.viewCollectionConfirm = null;

        $(() => {
            $('body')
                .on('click', '.opb-use-template-btn', this.useTemplateClick.bind(this))
                .on('click', '.opb-preview-template-btn', this.previewTemplateClick.bind(this))
                .on('click', '.opb-view-collection-btn', this.viewCollection.bind(this));
        })
    }

    /**
     * Opens dialog when click on "Use This Template" Button
     *
     * @param e
     * @return {Void}
     */
    useTemplateClick(e) {
        e.preventDefault();

        if (!OP3General.checkLicense())
            return;

        // Sometimes "Use This Template" is clicked inside 
        // "View Collection" popup so we force popup close
        // to avoid situation with 2 popups.
        if (this.viewCollectionConfirm)
            this.viewCollectionConfirm.close();

        let _this = this;
        let $target = $(e.currentTarget);
        let $templateList = $target.closest('.opb-template-list');
        let $templateListItem = $target.closest('.opb-template-list-item');
        let nonceValue = $templateList.find('#nonce-create-new-page').val();
        let templateUid = $templateListItem.data('template-uid');
        let categoryUid = $templateListItem.data('category-uid');
        let dialogOptions = window.OP3General.dialogOptions;

        this.useTemplateConfirm = $.dialog(Object.assign(dialogOptions, {
            theme: 'optimizepress,optimizepress-mini',
            title: 'Create New OptimizePress Page',
            content: () => {
                let options = {
                    adminUrl: $target.attr('href'), 
                    nonceValue: nonceValue, 
                    templateUid: templateUid, 
                    categoryUid: categoryUid, 
                    postTypes: window.OpsScriptData.enabled_post_types, 
                };

                return _this.getCreateNewPageForm(options);
            },
        }));
    }

    /**
     * Opens dialog when click on "Preview Template" Button
     *
     * @param {Object} e
     * @return {Void}
     */
    previewTemplateClick(e) {
        e.preventDefault();

        let $target = $(e.currentTarget);
        let $templateListItem = $target.closest('.opb-template-list-item');
        let dialogOptions = window.OP3General.dialogOptions;
        let templateName = $templateListItem.find('h4').text();
        let bigImage = $templateListItem.data('big-image');

        this.previewTemplateConfirm = $.dialog(Object.assign(dialogOptions, {
            theme: 'optimizepress,optimizepress-mini',
            title: templateName,
            content: () => {
                return `<img src="${bigImage}">`;
            }
        }));
    }

    /**
     * Open "Create New Optimizepress Page" dialog with form that creates new page
     *
     * @param {Object} e
     * @return {Void}
     */
    viewCollection(e) {
        e.preventDefault();

        let _this = this;
        let $target = $(e.currentTarget);
        let collectionTitle = $target.data('collection-title');
        let collectionUid = $target.data('collection-uid');
        let dialogOptions = window.OP3General.dialogOptions;

        this.viewCollectionConfirm = $.dialog(Object.assign(dialogOptions, {
            theme: 'optimizepress,optimizepress-mini',
            title: collectionTitle,
            content: () => {
                return $.get(
                    OpsScriptData.ajax_url,
                    {
                        'action': 'opb_templates',
                        'collection': collectionUid
                    },
                    (response) => {
                        _this.viewCollectionConfirm.setContent(response);
                    }
                )
            },
            onContentReady: () => {
                new OP3MovingImage('.ops-moving-image');
            }
        }));
    }

    /**
     * Form HTML that is submitted upon creating new OptimizePress page
     *
     * @todo Boris - Added nonce "nonce-create-new-page" that should be checked in backend file PagesController::store
     *
     * @param {Array} options
     * @return {String}
     */
    getCreateNewPageForm(options) {
        const defaultOptions = {
            adminUrl: null, 
            nonceValue: null, 
            templateUid: null, 
            fieldTitle: 'Page Title', 
            fieldPlaceholder: 'Enter Page Title', 
            submitText: 'Create Page', 
            submittingText: 'Creating Page...', 
            categoryUid: null, 
            postTypesTitle: 'Create Page', 
            postTypes: [],
        };

        options = {...defaultOptions, ...options};

        return `
            <div class="ops-container-fluid">
                <form class="ops-form ops-form-single-submit" method="post" action="${options.adminUrl}">
                    <input type="hidden" id="nonce-create-new-page" name="nonce-create-new-page" value="${options.nonceValue}">
                    <input type="hidden" name="action" value="op-builder-store-page">
                    <input type="hidden" name="template_id" value="${options.templateUid}">
                    <input type="hidden" name="category_uid" value="${options.categoryUid}">
                    <div class="ops-row">
                        <div class="ops-col-8">
                            <div class="ops-form-group">
                                <label for="opb-pageTitle">${options.fieldTitle}</label>
                                <input id="opb-pageTitle" type="text" name="title" value="" placeholder="${options.fieldPlaceholder}" class="ops-form-control" required>
                            </div>
                        </div>
                        <div class="ops-col-4">
                            <div class="ops-form-group">
                                <label for="opb-pageTitle">${options.postTypesTitle}</label>
                                <select name="post_type" class="ops-form-control" required style="max-width: 100%;font-size: 15px;line-height:23px;width:100% !important">
                                    <option value="page">Page</option>
                                    ${options.postTypes.map((item, i) => `
                                        <option value="${item.id}">${item.title}</option>
                                    `.trim()).join('')}
                                </select>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="ops-button" data-submit-text="${options.submittingText}">${options.submitText}</button>
                </form>
            </div>`;
    }
}